var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.939,
    height: 12.449,
    viewBox: "0 0 14.939 12.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase",
    transform: "translate(0 -42.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58566",
    "data-name": "Group 58566",
    transform: "translate(0 42.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58565",
    "data-name": "Group 58565",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11235",
    "data-name": "Path 11235",
    d: "M13.694,44.533H10.582v-.622a1.246,1.246,0,0,0-1.245-1.245H5.6a1.246,1.246,0,0,0-1.245,1.245v.622H1.245A1.246,1.246,0,0,0,0,45.778v1.867a1.246,1.246,0,0,0,1.245,1.245h4.98v-.311a.311.311,0,0,1,.311-.311H8.4a.311.311,0,0,1,.311.311v.311h4.98a1.246,1.246,0,0,0,1.245-1.245V45.778A1.246,1.246,0,0,0,13.694,44.533Zm-4.357,0H5.6v-.622H9.337Z",
    transform: "translate(0 -42.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11236",
    "data-name": "Path 11236",
    d: "M14.766,266.416a.312.312,0,0,0-.326.031,1.229,1.229,0,0,1-.746.256H8.714v.934a.311.311,0,0,1-.311.311H6.536a.311.311,0,0,1-.311-.311V266.7H1.245a1.229,1.229,0,0,1-.746-.256.311.311,0,0,0-.5.248v4.365a1.246,1.246,0,0,0,1.245,1.245H13.694a1.246,1.246,0,0,0,1.245-1.245V266.7A.311.311,0,0,0,14.766,266.416Z",
    transform: "translate(0 -259.856)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.b181d7fa753b381dd88dbc47c63befa9.svg";
export { ForwardRef as ReactComponent };